import holidaysApi from './holidays.api';

const get = () => holidaysApi.get();

export default { get };
